
window.visitFormInit = new (function () {

    this._screenWebWorker = null;

    this.initScreenWebWorker = (arg) => {
        this.stopScreenWebWorker();

        this._screenWebWorker = new Worker(new URL("./screenWorker.js", import.meta.url));

        this._screenWebWorker.onmessage = (msg) => {

            // 

            try {
                DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'OnWebWorkerMessageScreen', msg.data);
                //handler.invokeMethodAsync(method, msg.data);
            } catch (e) {
                console.warn("Failed to call WebWorker callback: " + e);
            }

            //const accessToken = localStorage.getItem("accessToken");
            //if (accessToken) {
               
            //}
        };
    };

    this.stopScreenWebWorker = () => {
        if (this._screenWebWorker) {
            console.log("Stopping WebWorker.");
            this._screenWebWorker.terminate();
            this._screenWebWorker = null;
        }
    };
})();

window.callMethodOnObject = (el, func, ...args) => {
    el[func](...args);
};

window.callFunct = (func, ...args) => {
    if (window.visitFormInit[func]) {
        try {
            return window.visitFormInit[func](...args);
        } catch (e) {
            console.warn(e);
        }
    } else {
        console.error("interop func not defined: " + func);
    }
};

window.mediaPicker = {
    capturePhoto: async function () {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: true });
            const track = stream.getVideoTracks()[0];
            const imageCapture = new ImageCapture(track);

            const photoBlob = await imageCapture.takePhoto();

            // Convert the Blob to a base64-encoded string
            const base64String = await new Promise((resolve) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result.split(',')[1]);
                reader.readAsDataURL(photoBlob);
            });
            return base64String;
        }
        catch { }

        return "";
    },

    checkCameraSupport: async function () {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: true });

            return true;
        }
        catch {
            return false;
        }
    }
};

